import { render, staticRenderFns } from "./ServicesTableSkeletonItem.vue?vue&type=template&id=10a92b3d&scoped=true"
import script from "./ServicesTableSkeletonItem.vue?vue&type=script&lang=js"
export * from "./ServicesTableSkeletonItem.vue?vue&type=script&lang=js"
import style0 from "./ServicesTableSkeletonItem.vue?vue&type=style&index=0&id=10a92b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a92b3d",
  null
  
)

export default component.exports